import DOMPurify from "dompurify";
import moment from "moment";
import authService from "../../../services/authService";

moment.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "1s",
    ss: "%ss",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1M",
    MM: "%dM",
    y: "1Y",
    yy: "%dY",
  },
});

const Message = ({ item, index, data }) => {
  const user = authService.getCurrentUser();

  const previous_index = index !== 0 ? index - 1 : 0;
  const previous_item = data[previous_index];

  const { sender_id, sender, created_on, sent_on, text_message, attachment } =
    item;

  const temp_message = attachment
    ? `<a class="underline" href="${attachment}" rel="noreferrer" target="_blank">${text_message}</a>`
    : text_message;

  const message = DOMPurify.sanitize(temp_message, {
    ALLOWED_TAGS: ["br", "a"],
    ALLOWED_ATTR: ["rel", "target", "href", "class"],
  });

  if (sender_id !== user.user_id) {
    return (
      <div key={index} className="col-start-1 col-end-10 space-y-1 rounded-lg">
        <div className="flex flex-row">
          {sender_id === previous_item.sender_id &&
          sent_on === previous_item.sent_on &&
          previous_index !== 0 ? (
            <>
              <div className="flex items-center justify-center h-7 w-7 ml-5"></div>
              <div className="relative ml-3 text-sm bg-gray-100 py-2 px-4 rounded-xl">
                <div
                  className="text-gray-700"
                  dangerouslySetInnerHTML={{
                    __html: message,
                  }}
                ></div>
                <div className="text-xs text-right text-gray-400">
                  {moment(created_on).fromNow(true)}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center justify-center h-7 w-7 ml-5 rounded-full bg-gray-300 flex-shrink-0">
                <span className="text-sm text-white">{sender.charAt(0)}</span>
              </div>
              <div className="relative ml-3">
                <div className="text-xs text-gray-400 mt-1 pb-3">{sender}</div>
                <div className="text-sm bg-gray-100 py-2 px-4 rounded-xl">
                  <div
                    className="text-gray-700"
                    dangerouslySetInnerHTML={{
                      __html: message,
                    }}
                  ></div>
                  <div className="text-xs text-right text-gray-400">
                    {moment(created_on).fromNow(true)}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      key={index}
      className="col-start-6 col-end-13 px-3 space-y-1 rounded-lg"
    >
      <div className="flex flex-row-reverse items-center">
        <div className="relative ml-3 text-sm bg-blue-500 py-2 px-4 rounded-xl">
          <div
            className="text-gray-200"
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Message;
